import { useEffect, useState } from 'react'

const useOnScreen = (ref, once) => {
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      const isOnScreen = entry.isIntersecting
      if (once) {
        isOnScreen && setIntersecting(true)
      } else {
        setIntersecting(isOnScreen)
      }
    }, { threshold: 0.75 })

    observer.observe(ref.current)
    return () => {
      observer.disconnect()
    }
  }, [])

  return isIntersecting
}

export { useOnScreen }
